/**
 * When a goodwill toggle turns off, clear the related status + claimedBy fields
 * so leftover values are not sent on save (and the UI stays consistent).
 *
 * ClaimedBy fields follow the convention: `${statusField}ClaimedBy`.
 */
const GOODWILL_TOGGLE_CLEAR_FIELDS: Record<string, string[]> = (() => {
  const pairs: [string, string][] = [
    ["home.treeDebrisInfo.goodwillTreeWorkOn", "home.treeDebrisInfo.goodwillTreeWorkNeeded"],
    ["home.treeDebrisInfo.goodwillExteriorDebrisOn", "home.treeDebrisInfo.goodwillExteriorDebrisRemovalNeeded"],
    ["home.treeDebrisInfo.goodwillHeavyEquipmentOn", "home.treeDebrisInfo.goodwillHeavyEquipmentNeeded"],
    ["home.roofingInfo.goodwillRoofingOn", "home.roofingInfo.goodwillRoofing"],
    ["home.roofingInfo.goodwillRoofTarpOn", "home.roofingInfo.goodwillRoofTarpNeeded"],
    ["home.crawlSpaceInfo.goodwillCrawlSpaceInsulationOn", "home.crawlSpaceInfo.goodwillCrawlSpaceInsulation"],
    ["home.crawlSpaceInfo.goodwillCrawlSpaceMuckOn", "home.crawlSpaceInfo.goodwillCrawlSpaceMuck"],
    ["home.muckGutInfo.goodwillMuckGutNeededOn", "home.muckGutInfo.goodwillMuckGutNeeded"],
    ["home.moldRemediationInfo.goodwillMoldRemediationOn", "home.moldRemediationInfo.goodwillMoldRemediation"],
    ["home.rebuildPrepInfo.goodwillRebuildPrepOn", "home.rebuildPrepInfo.goodwillRebuildPrep"],
    ["home.roughCarpentryInfo.goodwillRoughCarpentryOn", "home.roughCarpentryInfo.goodwillRoughCarpentry"],
    ["home.electricalInfo.goodwillElectricalOn", "home.electricalInfo.goodwillElectrical"],
    ["home.electricalInfo.goodwillElectricalRoughInOn", "home.electricalInfo.goodwillElectricalRoughIn"],
    ["home.hvacInfo.goodwillHvacOn", "home.hvacInfo.goodwillHvac"],
    ["home.hvacInfo.goodwillMechanicalRoughInOn", "home.hvacInfo.goodwillMechanicalRoughIn"],
    ["home.plumbingInfo.goodwillPlumbingOn", "home.plumbingInfo.goodwillPlumbing"],
    ["home.plumbingInfo.goodwillPlumbingRoughInOn", "home.plumbingInfo.goodwillPlumbingRoughIn"],
    ["home.insulationInstallInfo.goodwillInsulationInstallOn", "home.insulationInstallInfo.goodwillInsulationInstall"],
    ["home.drywallHangingInfo.goodwillDrywallHangingOn", "home.drywallHangingInfo.goodwillDrywallHanging"],
    ["home.mudAndTapeInfo.goodwillMudAndTapeOn", "home.mudAndTapeInfo.goodwillMudAndTape"],
    ["home.blockWallInfo.goodwillBlockWallRepairOn", "home.blockWallInfo.goodwillBlockWallRepair"],
    ["home.stuccoInfo.goodwillStuccoOn", "home.stuccoInfo.goodwillStucco"],
    ["home.bathroomRebuildInfo.goodwillBathroomRebuildOn", "home.bathroomRebuildInfo.goodwillBathroomRebuild"],
    ["home.cabinetInstallInfo.goodwillCabinetInstallOn", "home.cabinetInstallInfo.goodwillCabinetInstall"],
    ["home.cabinetInstallInfo.goodwillCounterInstallOn", "home.cabinetInstallInfo.goodwillCounterInstall"],
    ["home.cabinetInstallInfo.goodwillApplianceInstallOn", "home.cabinetInstallInfo.goodwillApplianceInstall"],
    ["home.interiorPaintInfo.goodwillInteriorPaintOn", "home.interiorPaintInfo.goodwillInteriorPaint"],
    ["home.flooringInstallInfo.goodwillFlooringInstallOn", "home.flooringInstallInfo.goodwillFlooringInstall"],
    ["home.installInteriorDoorsInfo.goodwillInstallInteriorDoorsOn", "home.installInteriorDoorsInfo.goodwillInstallInteriorDoors"],
    ["home.trimInstallInfo.goodwillTrimInstallOn", "home.trimInstallInfo.goodwillTrimInstall"],
    ["home.exteriorDoorInstallInfo.goodwillExteriorDoorInstallOn", "home.exteriorDoorInstallInfo.goodwillExteriorDoorInstall"],
    ["home.drivewayRepair.goodwillDrivewayRepairOn", "home.drivewayRepair.goodwillDrivewayRepair"],
    ["home.stormShutters.goodwillShutterInstallOn", "home.stormShutters.goodwillShutterInstall"],
  ]

  const map: Record<string, string[]> = {}
  for (const [onPath, statusPath] of pairs) {
    map[onPath] = [statusPath, `${statusPath}ClaimedBy`]
  }
  return map
})()

/** Status + claimedBy field paths to null out when a goodwill toggle is turned off. */
export function getGoodwillFieldsToClear(togglePath: string): string[] {
  return GOODWILL_TOGGLE_CLEAR_FIELDS[togglePath] ?? []
}
